// Özlük belgesi yükleme alanlarının kabul ettiği dosya türleri.
//
// Neden ortak bir sabit: aynı kural en az iki ekranda geçerli — İK'nın çalışan adına
// yüklediği "Çalışan Belgeleri" ve çalışanın kendi yüklediği "Belgelerim". İkisi farklı
// listeler taşırsa, kullanıcı bir ekranda seçebildiği dosyayı diğerinde seçemez ve bu
// fark hiçbir testte görünmez.
//
// `image/*` tek başına YETMEZ (PictureUpload'ın kendi varsayılanı odur): özlük belgeleri
// çoğunlukla PDF gelir, taranmış görsel ikinci sıradadır. Office türleri sözleşme ve
// bordro eklerinde kullanılıyor.
export const DOCUMENT_ACCEPT = 'application/pdf,image/*,.doc,.docx,.xls,.xlsx';

export default DOCUMENT_ACCEPT;
